import VerticalCarousel from '@component/carousel/src/views/VerticalCarousel';
import HorizontalCarousel from '../components/CustomHorizontalCarousel';
import ColorSwatchesCarousel from '../components/ColorSwatchesCarousel';
import Constants from '../util/Constants';

export {
  default as Carousel,
  ArrowIconSize,
  ScrollType,
  NEXT_EVENT,
  PREV_EVENT,
  READY_EVENT,
  LAST_PAGE_EVENT,
  PAGE_SHOWN_EVENT,
  SWIPE_EVENT,
  HORIZONTAL,
  VERTICAL,
  SLIDE_CHANGED,
} from '@component/carousel/src/views/Carousel';

/**
 * Factory function for carousel component.
 *
 * @param carouselType
 * @param options
 * @return {*}
 */
export function createCarouselView(carouselType, options) {
  let view = null;
  if (carouselType === Constants.CAROUSEL_TYPE.HORIZONTAL) {
    view = new HorizontalCarousel(options);
  } else if (carouselType === Constants.CAROUSEL_TYPE.COLORSWATCHES) {
    view = new ColorSwatchesCarousel(options);
  } else if (carouselType === Constants.CAROUSEL_TYPE.VERTICAL) {
    view = new VerticalCarousel(options);
  }
  return view;
}

export { VerticalCarousel, HorizontalCarousel };
